/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        //Open the first panel-group element on page load (requires the open-first class)
        if( $('.panel-group').length > 0){
            setTimeout(function(){
                $('.panel-group.open-first .panel:first-child').find('.collapse').collapse('toggle');
            },600);
        }

        //Pagination fix - hide the "-"
        if( $('.nav-links').length > 0 ){
            if( $('.nav-next').length > 0 && $('.nav-previous').length == 0 ){
                $('.nav-next').addClass('hiddenafter');
            }
        }

        //Bootstrap carrousel init
        $('#carousel').carousel({'keyboard':true, 'interval':4000 });

        //On slide, we hide the same legend index
        $('#carousel').on('slide.bs.carousel', function (d) {
            var index = $('.item').index($('.item.active'));
            $('.legende:eq('+index+')').fadeOut('fast', function(){
                $(this).removeClass('active');
            });
        });

        //On finish, we show the same legend index
        $('#carousel').on('slid.bs.carousel', function (d) {
            var index = $('.item').index(d.relatedTarget);
            $('.legende:eq('+index+')').fadeIn('fast', function(){
                $(this).addClass('active');
            });
        });

      },
      finalize: function() {
            //Mobile menu system - Doc : http://tympanus.net/Development/SidebarTransitions/
            var SidebarMenuEffects = (function() {

            function hasParentClass( e, classname ) {
                if(e === document) return false;
                if( $(e).hasClass( classname ) ) {
                    return true;
                }
                return e.parentNode && hasParentClass( e.parentNode, classname );
            }

            // http://coveroverflow.com/a/11381730/989439
            function mobilecheck() {
                var check = false;
                (function(a){if(/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
                return check;
            }

            function init() {
                var container = document.getElementById( 'st-container' ),
                    buttons = Array.prototype.slice.call( document.querySelectorAll( '#st-trigger-effects > button' ) ),
                    // event type (if mobile use touch events)
                    eventtype = mobilecheck() ? 'touchstart' : 'click',
                    resetMenu = function() {
                        $(container).removeClass( 'st-menu-open' );
                    },
                    bodyClickFn = function(evt) {
                        if( !hasParentClass( evt.target, 'st-menu' ) ) {
                            resetMenu();
                            document.removeEventListener( eventtype, bodyClickFn );
                        }
                    };

                buttons.forEach( function( el, i ) {
                    var effect = el.getAttribute( 'data-effect' );

                    el.addEventListener( eventtype, function( ev ) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        container.className = 'st-container'; // clear
                        $(container).addClass( effect );
                        setTimeout( function() {
                            $(container).addClass( 'st-menu-open' );
                            $('body').css('background','#fff');
                        }, 25 );
                        document.addEventListener( eventtype, bodyClickFn );
                    });
                } );
            }

            init();

        })();
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        $(window).on('load', function(){
          //Masonry block - Doc : http://masonry.desandro.com/
          $('.masonry').masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.grid-item',
            // use element for option
            columnWidth: '.grid-sizer',
            percentPosition: true
          });
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    'single_webapp': {
      init: function() {
        //Doc : https://github.com/alvarotrigo/fullPage.js#fullpagejs
        $('#fullpage').fullpage({
            normalScrollElements: $('.text-section'),
            anchors: ['textPage', 'firstPage', 'soundPage'],
            slidesNavigation: false,
            autoScrolling: true,
            slideSelector: '.slide-tanneries',
        });
        //Carousel webapp init
        $('#carousel-webapp, #carousel-webapp2').carousel({ 'keyboard':true, 'interval':0 });
      }
    },
    // Agenda
    'post_type_archive_agenda': {
      init: function() {
        //Select on change : close elements but not selected, scroll to selected
        $(document).on('change','.month-selection > select', function(){
            //If selected element is empty, we close all elements
            if( $(this).val() == ''){
                $('.collapse').collapse('hide');
            }else{
                $('.collapse:not(#'+$(this).val()+')').collapse('hide');
                if( !$('.collapse#'+$(this).val()).hasClass('in') ){
                    $('.panel-collapse#'+$(this).val()).collapse('show');
                    //When item is displayed, the window auto scroll until its top
                    $('.panel-group').on('shown.bs.collapse', function(item){
                        var target = $(item.target).parents('.panel-custom');
                        $('html,body').animate({ scrollTop: $(target).offset().top}, 300);
                    });
                }
            }
        });
        //When page loads, auto scroll to the opened element
        setTimeout(function(){
            $('html,body').animate({ scrollTop: $('.collapse.in').offset().top}, 300);
        },500);
      }
    },
    'page_template_template_informations': {
        init: function(){
            //Create new map
            function new_map( $el ) {
                // var
                var $markers = $el.find('.marker');
                // vars
                var args = {
                    zoom        : 16,
                    center      : new google.maps.LatLng(0, 0),
                    mapTypeId   : google.maps.MapTypeId.ROADMAP
                };
                // create map
                var map = new google.maps.Map( $el[0], args);
                // add a markers reference
                map.markers = [];
                // add markers
                $markers.each(function(){
                    add_marker( $(this), map );
                });
                // center map
                center_map( map );
                // return
                return map;
            }

            //Add marker
            function add_marker( $marker, map ) {
                // var
                var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
                //Retina marker icon
                if( window.devicePixelRatio > 1.5 ){
                    var markerIconVersion = $marker.attr('data-icon2');
                }else{
                    var markerIconVersion = $marker.attr('data-icon');
                }
                var markerIcon = new google.maps.MarkerImage(markerIconVersion, null, null, null, new google.maps.Size(26,26));
                // create marker
                var marker = new google.maps.Marker({
                    position    : latlng,
                    map         : map,
                    icon        : markerIcon
                });
                // Règle spécifique pour éviter un bug sur certaines version de l'API
                if (window.devicePixelRatio > 1.5) {
                    marker.setOptions({ optimized: false });
                }
                // add to array
                map.markers.push( marker );
                // if marker contains HTML, add it to an infoWindow
                if( $marker.html() )
                {
                    // create info window
                    var infowindow = new google.maps.InfoWindow({
                        content     : $marker.html()
                    });
                    // show info window when marker is clicked
                    google.maps.event.addListener(marker, 'click', function() {
                        infowindow.open( map, marker );
                    });
                }
            }

            //Auto center map and show all markers
            function center_map( map ) {
                // vars
                var bounds = new google.maps.LatLngBounds();
                // loop through all markers and create bounds
                $.each( map.markers, function( i, marker ){
                    var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
                    bounds.extend( latlng );
                });
                // only 1 marker?
                if( map.markers.length == 1 )
                {
                    // set center of map
                    map.setCenter( bounds.getCenter() );
                    map.setZoom( 16 );
                }
                else
                {
                    // fit to bounds
                    map.fitBounds( bounds );
                }
            }

            //Init map
            var map = null;
            $('.map').each(function(){
                // create map
                map = new_map( $(this) );
            });
        }
    },
    // Home page
    'page_template_template_newsletter': {
      init: function() {
        $('#newsletterForm').on('submit', function(e) {
          e.preventDefault(); // J'empêche le comportement par défaut du navigateur, c-à-d de soumettre le formulaire
          var $this = $(this);
          var mail = $('#email').val();
          var regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-zA-Z]{2,4}$/;

          if( mail === '' || !regex.test(mail)) {
            $("#reponseNewsletterNo").html("Le champ email doit être rempli correctement.<br/>ex: nom@domaine.xxx ");
          } else {
            
            $.ajax({
              url: $this.attr('action'),
              type: $this.attr('method'),
              data: $this.serialize(),
              success: function(msg) {
                if(msg == 'success' ) {
                  $("#reponseNewsletterNo").html("");
                  $("#reponseNewsletterOk").html("");
                  $('#email').val("");
                  $("#reponseNewsletterOk").show();
                  $("#reponseNewsletterOk").html("Votre inscription a été prise en compte.<br/>Un email de confirmation vous a été envoyé");
                  $("#reponseNewsletterOk").fadeOut(5000, function() {
                    $("#email").html("");
                    $("#email").show();
                  });
                } else {
                  $("#reponseNewsletterNo").html("Problème lors de l'inscription<br/>Merci de réessayer ultérieurement");
                  /*
                   if(json.reponse === 'existe'){

                   //alert('cette email existe deja');
                   $("#mail").css("border-color","red");
                   //$("#mail").attr("placeholder", "Type your answer here");
                   $("#reponseNewsletterNo").html("cette email existe deja");

                   }else{

                   alert('Erreur : '+ json.reponse);
                   }
                   */
                }
              }
            });
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
